// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1___51325794403b6f0bce8","cls2":"ContentFeedback-cls2___09c81133d8e81a4eadb ContentFeedback-cls1___51325794403b6f0bce8"};